import { EntityReference } from './entity-reference'

export class SoftFilter {
  entityReference: EntityReference
  softFilterExpression: string
  resultType: string

  constructor(entityReference: EntityReference, expression: string, resultType?: string) {
    this.entityReference = entityReference
    this.softFilterExpression = expression
    this.resultType = resultType
  }
}
